import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { style } from "typestyle";
import { ReactComponent as IconInfo } from "../../assets/icons/tag_icon.svg";
import { Badge } from "@hooplab/ui-components";
import colors from "../../styles/colors";

type CategoryBadgeProps = {
  category: string;
};

export type CategoryName =
  | "CONCERT"
  | "CONFERENCE"
  | "FESTIVAL"
  | "SEMINAR"
  | "COURSE"
  | "SHOW"
  | "SPORTS"
  | "EXHIBITION"
  | "GATHERING"
  | "OTHER";

export const categoryNameMessages = defineMessages<CategoryName>({
  CONCERT: {
    id: "constants.eventCategoryNames.concert",
    defaultMessage: "Concert",
  },
  CONFERENCE: {
    id: "constants.eventCategoryNames.conference",
    defaultMessage: "Conference",
  },
  FESTIVAL: {
    id: "constants.eventCategoryNames.festival",
    defaultMessage: "Festival",
  },
  SEMINAR: {
    id: "constants.eventCategoryNames.seminar",
    defaultMessage: "Lecture",
  },
  COURSE: {
    id: "constants.eventCategoryNames.course",
    defaultMessage: "Course",
  },
  SHOW: {
    id: "constants.eventCategoryNames.show",
    defaultMessage: "Show",
  },
  SPORTS: {
    id: "constants.eventCategoryNames.sports",
    defaultMessage: "Sports",
  },
  EXHIBITION: {
    id: "constants.eventCategoryNames.exhibition",
    defaultMessage: "Exhibition",
  },
  GATHERING: {
    id: "constants.eventCategoryNames.gathering",
    defaultMessage: "Gathering/Party",
  },
  OTHER: {
    id: "constants.eventCategoryNames.other",
    defaultMessage: "Other…",
  },
});

function isOfType(category: string) {
  return [
    "CONCERT",
    "CONFERENCE",
    "FESTIVAL",
    "SEMINAR",
    "COURSE",
    "SHOW",
    "SPORTS",
    "EXHIBITION",
    "GATHERING",
    "OTHER",
  ].includes(category);
}

const CategoryBadge: React.FC<CategoryBadgeProps> = (props) => {
  const intl = useIntl();
  const category = props.category as CategoryName;

  return (
    <Badge
      icon={
        <IconInfo
          width={14}
          height={14}
          color={colors.grey[400]}
          className={style({ minWidth: 14, stroke: colors.grey[400], strokeWidth: 1.5 })}
        />
      }
    >
      {isOfType(category) ? intl.formatMessage(categoryNameMessages[category]) : category}
    </Badge>
  );
};
export default CategoryBadge;
